// The path a person was trying to reach when they hit sign-in with no session yet — e.g.
// the costs report link from the debug panel, opened in a fresh tab. Per tab, dies with
// the tab: the same posture as the session token and `invite-stash.ts`.
//
// The sign-in vendor decides for itself where to land after authenticating (see
// `invite-stash.ts`'s own header — the first live redemption proved this), and it lands
// on the plans list. Without this, any deep link followed while signed out — not just an
// invitation — loses its destination the same way.

const STASH_KEY = 'mor.postSignIn.returnPath';

const listeners = new Set<() => void>();

export function subscribeReturnPathStash(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function pendingReturnPath(): string | null {
  try {
    return window.sessionStorage.getItem(STASH_KEY);
  } catch {
    return null;
  }
}

export function stashReturnPath(value: string | null): void {
  try {
    if (value === null) {
      window.sessionStorage.removeItem(STASH_KEY);
    } else {
      window.sessionStorage.setItem(STASH_KEY, value);
    }
  } catch {
    // A browser that refuses the store degrades to landing on the plans list, same as
    // today.
  }
  for (const listener of listeners) {
    listener();
  }
}
